export function formatName(obj = {}, opts = {}) {
  // opts:
  // - lastFirst: true -> "Lastname, Firstname M. Suffix"
  // - middle: "full" | "initial" | "none" (default: "full")
  // - capitalize: true -> title-case words
  const lastFirst = opts.lastFirst !== undefined ? opts.lastFirst : true;
  const middleMode = opts.middle || 'full';
  const capitalize = !!opts.capitalize;
  if (!obj) return '';
  const title = (v) => String(v || '')
    .toLowerCase()
    .replace(/\b([a-z])/g, (m) => m.toUpperCase())
    .replace(/\s+/g, ' ')
    .trim();
  const pick = (v) => (capitalize ? title(v) : String(v || '').trim());

  const firstname = pick(obj.firstname || obj.first_name || obj.firstName || '');
  const middlenameRaw = pick(obj.middlename || obj.middle_name || obj.middleName || '');
  const lastname = pick(obj.lastname || obj.last_name || obj.lastName || '');
  const suffix = pick(obj.suffix || '');
  // If no name parts present, fall back to sensible identifier
  if (!firstname && !lastname && !middlenameRaw) {
    return (obj.username || obj.user || obj.email || obj.employeeid || obj.employee_id || '').toString();
  }

  const middle = middleMode === 'none'
    ? ''
    : middleMode === 'initial'
      ? (middlenameRaw ? `${middlenameRaw[0].toUpperCase()}.` : '')
      : middlenameRaw;

  const firstAndMiddle = [firstname, middle].filter(Boolean).join(' ').trim();
  let name = '';
  if (lastFirst) {
    name = `${lastname}${lastname ? ', ' : ''}${firstAndMiddle}`.trim();
    if (suffix) name = `${name} ${suffix}`.trim();
  } else {
    name = `${firstAndMiddle}${firstAndMiddle ? ' ' : ''}${lastname}`.trim();
    if (suffix) name = `${name} ${suffix}`.trim();
  }
  // normalize whitespace and remove newlines
  return name.replace(/\s+/g, ' ').replace(/\r?\n/g, ' ').trim();
}

export default formatName;
